import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b7e7faf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "artist-card-container" }
const _hoisted_2 = { class: "artist-card" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.label), 1)
    ]),
    _createElementVNode("div", {
      class: "artist-card-hover-menu",
      style: _normalizeStyle([!_ctx.date || !_ctx.hour ? { display: 'none' } : { display: 'flex' }])
    }, [
      _createElementVNode("p", null, _toDisplayString(_ctx.date), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.hour), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.place), 1)
    ], 4),
    _createElementVNode("img", {
      src: _ctx.image,
      alt: _ctx.name
    }, null, 8, _hoisted_3)
  ]))
}